import { FormFieldBase } from './form-field-base.model';

export class FormFieldDropdown extends FormFieldBase<string> {
  override controlType = 'dropdown';
}
